"use client";
import { useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { StepProps } from "../../Steps.types";

export default function Steps_About_Layout3({ data }: StepProps) {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  // ✅ Always make sure Step is an array
  const steps = Array.isArray(data?.Step) ? data.Step : [];

  const toggleAccordion = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="px-6 py-8 md:px-24 lg:px-8 lg:py-10 bg-th-bg-col">
      <div className="max-w-xl mx-auto mb-10 text-center lg:max-w-2xl">
        <h1 className="text-3xl xl:text-4xl font-bold text-[#1f1f1f]">
          {data?.title || "Title"}
        </h1>
        <p className="mt-4 text-lg text-[#797979]">
          {data?.description || ""}
        </p>
      </div>

      <div className="max-w-4xl mx-auto">
        {steps.length === 0 ? (
          <p className="text-center text-gray-500 py-6">
            No steps available.
          </p>
        ) : (
          steps.map((item, idx) => {
            const imageUrl = item?.iconImage?.data?.attributes?.url || "";
            const altText =
              item?.iconImage?.data?.attributes?.alternativeText ||
              "Step Image";

            return (
              <div key={idx} className="mb-4">
                <button
                  onClick={() => toggleAccordion(idx)}
                  className="w-full flex items-center justify-between p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition"
                >
                  <div className="flex items-center">
                    <div className="w-12 h-12 mr-4 flex-shrink-0">
                      {imageUrl ? (
                        <Image
                          src={imageUrl}
                          alt={altText}
                          width={48}
                          height={48}
                          className="w-full h-full object-cover rounded-full"
                        />
                      ) : (
                        <div className="w-full h-full rounded-full bg-gray-100 flex items-center justify-center text-xs text-gray-400">
                          No Img
                        </div>
                      )}
                    </div>
                    <h3 className="text-xl font-bold text-[#1f1f1f]">
                      {item?.title || "Untitled"}
                    </h3>
                  </div>
                  <span className="text-2xl">
                    {activeIndex === idx ? "−" : "+"}
                  </span>
                </button>

                {activeIndex === idx && (
                  <div className="p-6 bg-gray-50 rounded-b-lg">
                    <p className="text-[#797979] mb-4">
                      {item?.text || ""}
                    </p>
                    {item?.href && (
                      <Link
                        href={item.href}
                        className="inline-block px-4 py-2 text-sm font-semibold text-white bg-black rounded-full hover:bg-gray-800 transition"
                      >
                        {item?.hrefText || "Learn More"}
                      </Link>
                    )}
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
